import { apiClient } from './client';
import type { AdminUser } from '../store/adminAuthStore';

/** BFF 로그인 — 성공 시 user, MFA 필요 시 mfa_required. */
export interface LoginResult {
  user?: AdminUser;
  mfa_required?: boolean;
  mfa_enroll_required?: boolean;
  temp_token?: string;
  mfa_methods?: string[];
}

export async function adminLogin(email: string, password: string): Promise<LoginResult> {
  const { data } = await apiClient.post<LoginResult>('/auth/login', { email, password });
  return data;
}

export async function adminMfaVerify(tempToken: string, code: string, method?: string): Promise<LoginResult> {
  const { data } = await apiClient.post<LoginResult>('/auth/mfa/verify', { temp_token: tempToken, code, method });
  return data;
}

/**
 * 콘솔 2차 인증 «등록» (2026-10-15 콘솔 계정 분리) — 콘솔 2차 인증이 콘솔 자신의 표로 옮겨 와서,
 * 종전의 「메인 앱에서 먼저 등록하라」 대신 콘솔 안에서 등록한다.
 */
export interface MfaEnrollStart { secret: string; otpauth_uri: string }
export async function adminMfaEnrollStart(tempToken: string): Promise<MfaEnrollStart> {
  const { data } = await apiClient.post<MfaEnrollStart>('/auth/mfa/enroll', { temp_token: tempToken });
  return data;
}
export async function adminMfaEnrollConfirm(
  tempToken: string, code: string,
): Promise<LoginResult & { backup_codes?: string[] }> {
  const { data } = await apiClient.post<LoginResult & { backup_codes?: string[] }>(
    '/auth/mfa/enroll/confirm', { temp_token: tempToken, code },
  );
  return data;
}

/** 입력이 6자리 숫자면 앱 번호, 아니면 백업 코드(XXXXX-XXXXX)로 본다. */
export function mfaMethodOf(code: string): 'totp' | 'backup_code' {
  return /^[0-9]{6}$/.test(code.replace(/\s/g, '')) ? 'totp' : 'backup_code';
}

export async function adminLogout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function adminMe(): Promise<AdminUser> {
  const { data } = await apiClient.get<{ user: AdminUser }>('/auth/me');
  return data.user;
}

/** 세션 잔여시간 정보 — 사이드바 카운트다운용. */
export interface AdminSessionInfo {
  exp: number | null;        // 만료 시각(unix epoch seconds)
  ttl_sec: number;           // 세션 총 수명(초)
  remaining_sec: number | null;
}
export async function fetchAdminSession(): Promise<AdminSessionInfo> {
  const { data } = await apiClient.get<AdminSessionInfo>('/auth/session');
  return data;
}

/** sliding renewal — 유효 세션을 새 TTL 로 재발급(쿠키 재설정). 활동 감지 시 호출. */
export async function refreshAdminSession(): Promise<AdminSessionInfo> {
  const { data } = await apiClient.post<AdminSessionInfo>('/auth/refresh');
  return data;
}
